module.exports = __webpack_public_path__ + "img/result_txt_a.d877b80e.png";